/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */

const Wrapper = styled.div`
`;

const Title = styled.p`
	font-size: 20px;
	color: #3b3b3b
	padding-bottom: 15px;
`;

const Links = styled.ul`
	list-style: none outside;
	font-size: 16px;
	padding-left: 25px;
	padding-bottom: 25px;

	& li {
		padding-bottom: 5px;
	}
`;

const Link = styled.a`
	position: relative;
	text-decoration: none;
	color: #43abf3;

	&:before {
		content: '${({content}) => content}';
		position: absolute;
		display: block;
		left: -25px;
	}
`;

const Description = styled.div`
	font-size: 16px;
	color: #95989a;
`;

class Materials extends React.Component {
    constructor() {
        super();

        this.state = {
            selectedMaterial: null,
        };
    }

    toggleSelectedMaterial = (material) => {
        const {selectedMaterial} = this.state;

        this.setState({selectedMaterial: material !== selectedMaterial ? material : null});
    };

    render() {
        const {materials} = this.props;
        //const { selectedMaterial } = this.state;

        return (
            <Wrapper>
                <Title>Arbeitsanweisung:</Title>

                <div dangerouslySetInnerHTML={{__html: materials}}/>

                {/*<Links>*/}
                {/*{Object.keys(materials).map(material => (*/}
                {/*<li key={`materials-${material}`}>*/}
                {/*<Link*/}
                {/*onClick={() => this.toggleSelectedMaterial(material)}*/}
                {/*content={selectedMaterial !== material ? '+' : '–'}*/}
                {/*>*/}
                {/*{ material }*/}
                {/*</Link>*/}
                {/*</li>*/}
                {/*))}*/}
                {/*</Links>*/}

                {/*{ selectedMaterial && (*/}
                {/*<Description>*/}
                {/*{ materials[selectedMaterial] }*/}
                {/*</Description>*/}
                {/*)}*/}
            </Wrapper>
        );
    }
}

export default Materials;



// WEBPACK FOOTER //
// ./src/components/task/working/materials.js